<template>
    <div class="videoPlayer">
        <a-spin size="large" class="video-spin" v-show="spinVisible"/>
        <canvas :id=id></canvas>
        <div class="bottom" @mouseenter="moveIn" @mouseleave="moveOut">
            <div class="move" :style="moveStyle">
                <FullscreenOutlined  @click="fullFunc"/>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { ref } from 'vue'
import {FullscreenOutlined} from '@ant-design/icons-vue'
export default {
    name: "player",
    props: {
        url: String,
        id: String
    },
    setup(props) {
        const np = ref(undefined)
        const spinVisible = ref(false)
        const videoUrl = props.url
        const status = false
        const moveStyle = ref({})
        return {
            np,
            spinVisible,
            videoUrl,
            status,
            moveStyle
        }
    },
    mounted() {
        this.np = new NodePlayer()
        this.np.setView(this.id)
        this.np.setBufferTime(50) // 最大缓冲时间100
        this.np.setKeepScreenOn() // 保持屏幕常亮
        this.np.on("start", () =>{
            this.spinVisible = false
            this.status = true
        })
        // this.np.on("stats",(s)=>{
        //     console.log(s);
        // });
    },
    methods: {
        play(url) {
            this.np.stop()
            this.np.clearView()
            this.spinVisible = true
            if (this.status) {
                setTimeout(() => {
                    this.np.start(url)
                }, 100)
            } else {
                this.np.start(url)
            }
        },
        stop() {
            if (this.status) {
                this.np.stop()
            }
        },
        fullFunc() {
            this.np.fullscreen()
        },
        moveIn() {
            this.moveStyle = {bottom: '0'}
        },
        moveOut() {
            this.moveStyle = {bottom: '-50px'}
        },
    },
    beforeUnmount() {
        console.warn('video stopped!')
        this.np.stop()
    },
    components: {
        FullscreenOutlined
    }
}
</script>

<style scoped lang="stylus">
    .videoPlayer {
        width 100%
        height 100%
        position relative
        overflow hidden
        .video-spin {
            position absolute
            left 50%
            top 50%
            margin-left -15px
            margin-top -15px
            z-index 2
        }
        .bottom {
            width 100%
            height 50px
            position absolute
            left 0
            bottom 0
            z-index 1
        }
        .move {
            width 100%
            height 50px
            background rgba(0,0,0,0.5)
            display flex
            padding 0 20px
            justify-content flex-end
            align-items center
            color #FFF
            font-size 22px
            position absolute
            left 0
            bottom -50px
            z-index 2
            transition .2s
        }
        .move span:hover {
            cursor pointer
        }
    }
    .videoPlayer canvas {
        width 100%
        height 100%
    }
</style>